import React, { useEffect, useState } from "react";
import "../App.css";

const API_URL = "https://adroid-admin.vercel.app/api/v1/speakers";

const PrevKeynote = () => {
  const years = ["2025"];

  const [selectedYear, setSelectedYear] = useState("2025");
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    const fetchSpeakers = async () => {
      setLoading(true);
      setError("");
      setSpeakers([]);

      try {
        const params = new URLSearchParams({
          conference_id: "c4",
          year: selectedYear,
          type: "homepage",
          speaker_type: "keynote",
        });

        const response = await fetch(`${API_URL}?${params.toString()}`, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();
        setSpeakers(Array.isArray(data.items) ? data.items : []);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error fetching keynote speakers:", err);
          setError("Unable to load speakers. Please try again later.");
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchSpeakers();

    return () => controller.abort();
  }, [selectedYear]);

  return (
    <div className="keynote-speakers">
      {/* Tabs for Year Selection */}
      <div className="tabs">
        {years.map((year) => (
          <button
            key={year}
            onClick={() => setSelectedYear(year)}
            className={`tab-button ${
              selectedYear === year ? "active" : ""
            }`}
          >
            {year}
          </button>
        ))}
      </div>

      {/* Loading and Error States */}
      {loading && <p className="card-desc">Loading speakers...</p>}

      {!loading && error && (
        <p className="card-desc">{error}</p>
      )}

      {!loading && !error && speakers.length === 0 && (
        <p className="card-desc">
          No speakers found for {selectedYear}.
        </p>
      )}

      {/* Cards for Speakers */}
      {!loading && !error && speakers.length > 0 && (
        <div className="cards">
          {speakers.map((speaker) => (
            <div key={speaker.id} className="card">
              <img
                src={speaker.image_url}
                alt={speaker.name}
                className="card-image"
              />

              <p className="card-desc">{speaker.name}</p>
              <p className="card-desc">{speaker.designation}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PrevKeynote;